var colors = {
  transparent: 'transparent',
  current: 'currentColor',
  black: '#000000',
  white: '#FFFFFF',
  whiteAlpha: {
    50: 'rgba(255, 255, 255, 0.04)',
    100: 'rgba(255, 255, 255, 0.06)',
    200: 'rgba(255, 255, 255, 0.08)',
    300: 'rgba(255, 255, 255, 0.16)',
    400: 'rgba(255, 255, 255, 0.24)',
    500: 'rgba(255, 255, 255, 0.36)',
    600: 'rgba(255, 255, 255, 0.48)',
    700: 'rgba(255, 255, 255, 0.64)',
    800: 'rgba(255, 255, 255, 0.80)',
    900: 'rgba(255, 255, 255, 0.92)'
  },
  blackAlpha: {
    50: 'rgba(0, 0, 0, 0.04)',
    100: 'rgba(0, 0, 0, 0.06)',
    200: 'rgba(0, 0, 0, 0.08)',
    300: 'rgba(0, 0, 0, 0.16)',
    400: 'rgba(0, 0, 0, 0.24)',
    500: 'rgba(0, 0, 0, 0.36)',
    600: 'rgba(0, 0, 0, 0.48)',
    700: 'rgba(0, 0, 0, 0.64)',
    800: 'rgba(0, 0, 0, 0.80)',
    900: 'rgba(0, 0, 0, 0.92)'
  },
  gray: {
    100: '#F0F1F7',
    200: '#CDCCD4',
    300: '#BFBEC8',
    400: '#87868F',
    500: '#3F3E4B',
    600: '#32313C',
    700: '#25252D',
    800: '#19181E',
    900: '#0C0C0F',
    1000: '#060607'
  },
  blue: {
    200: '#E5F0F8',
    300: '#55B6F6',
    400: '#1098F3',
    500: '#0B87DB',
    600: '#0969AA',
    700: '#063C61',
    800: '#042D48',
    900: '#031E30'
  },
  red: {
    300: '#F78889',
    400: '#F46364',
    500: '#F13335',
    600: '#A70C0D',
    700: '#78191A',
    800: '#480F0F'
  },
  yellow: {
    100: '#fdf6d9',
    200: '#fbcd50',
    300: '#fbcb2f',
    400: '#FBC125',
    500: '#E1AD21',
    600: '#CA9D24',
    700: '#C0761A',
    800: '#965D16'
  },
  green: {
    300: '#5EE6B9',
    400: '#19DC9B',
    500: '#16C68B',
    600: '#119A6C',
    700: '#0C6E4D',
    800: '#07422E'
  }
};
var colors$1 = colors;
export { colors$1 as default };